/* eslint-disable import/extensions */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import {
  getScenarioEstimations,
  getScenarioEstimationsByDate,
  getScenarioEstimationsDaily,
} from "lib/requests/scenarios";
import SummaryTabs from "../summary-tabs/SummaryTabs";
import SummaryFilters from "../summary-filters/SummaryFilters";
import ScenarioMatrix from "./ScenarioMatrix";
import { setFetchingDataForScenarios } from "../duck/slices";
import useSummaryFilters from "../summary-filters/useSummaryFilters.js";
import ScenariosList from "../scenarios-list/ScenariosList";
import SummaryPromotionsComponent from "../promotions/SummaryPromotionsComponent";

const myStyles = makeStyles(() => ({
  mainContainer: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "5px",
    fontSize: "inherit",
    fontFamily: "inherit",
  },
  scenarioSummaryContainer: {
    flex: "1 1 auto",
    display: "flex",
    flexDirection: "row",
    gap: "5px",
    fontSize: "inherit",
    fontFamily: "inherit",
  },
}));

const ScenarioSummary = () => {
  // Hook Instances
  const classes = myStyles();

  // Hook Global States
  const dispatch = useDispatch();
  const { totalsByScenarioId } = useSelector((state) => state.scenarios);
  const { summaryFilters } = useSelector((state) => state.filters);
  const { selectedScenarios, fetchingDataForScenarios } = useSelector(
    (state) => state.summary
  );
  const [currentTab, setCurrentTab] = useState(0);
  const [selectedScenariosData, setSelectedScenariosData] = useState({});
  const [filteredScenariosData, setFilteredScenariosData] = useState(
    selectedScenariosData
  );
  const { filterScenariosData } = useSummaryFilters();

  const fetchDataForScenario = async (scenarioId) => {
    const currentScenario = totalsByScenarioId[scenarioId];
    try {
      let data = null;

      const baseFilters = {
        filters: {
          scenario: { id: scenarioId },
          // product: { id: [7, 8] },
          // retailer: { id: 3 },
          group_by: ["product_id", "retailer_id", "area_id"],
          sum: [
            "units",
            "units_in",
            "margin",
            "sales",
            "investment_in",
            "retailer_margin",
          ],
          avg_weight_by_units: ["price", "price_out_wo_taxes"],
          avg_weight_by_units_in: ["price_in", "price_in_wo_taxes"],
        },
      };

      const { cycle_type_id: cycleTypeId } = currentScenario.scenario.cycle;

      if (cycleTypeId === 1 || cycleTypeId === 2) {
        data = await getScenarioEstimations(baseFilters);
      } else if (cycleTypeId === 3) {
        data = await getScenarioEstimationsByDate(baseFilters);
      } else if (cycleTypeId === 4) {
        data = await getScenarioEstimationsDaily(baseFilters);
      }
      return data;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(`Error fetching scenario ${scenarioId}:`, error);
      return null;
    }
  };

  const addScenariosData = async () => {
    if (selectedScenarios.length === 0) return;
    const fetchDataFor = selectedScenarios.filter(
      (selectedScenarioId) => !selectedScenariosData[selectedScenarioId]
    );
    dispatch(setFetchingDataForScenarios(fetchDataFor));
    selectedScenarios.forEach(async (selectedScenarioId) => {
      if (selectedScenariosData[selectedScenarioId]) return;
      const res = await fetchDataForScenario(selectedScenarioId);
      if (res) {
        setSelectedScenariosData((prevData) => ({
          ...prevData,
          [selectedScenarioId]: res,
        }));
      }
    });
  };

  useEffect(() => {
    addScenariosData();
  }, [selectedScenarios]);

  useEffect(() => {
    if (fetchingDataForScenarios.length === 0) return;
    const everyScenarioLoaded = fetchingDataForScenarios.every(
      (selectedScenarioId) => selectedScenariosData[selectedScenarioId]
    );
    if (everyScenarioLoaded) {
      dispatch(setFetchingDataForScenarios([]));
    }
  }, [selectedScenariosData]);

  useEffect(() => {
    const scenariosDataFiltered = filterScenariosData(selectedScenariosData);
    setFilteredScenariosData(scenariosDataFiltered);
  }, [summaryFilters, selectedScenariosData]);

  return (
    <div className={classes.mainContainer}>
      <SummaryTabs setCurrentTab={setCurrentTab} />
      <SummaryFilters filteredScenariosData={filteredScenariosData} />
      <div className={classes.scenarioSummaryContainer}>
        {currentTab === 0 && <ScenariosList />}
        {currentTab === 0 && (
          <ScenarioMatrix selectedScenariosData={filteredScenariosData} />
        )}
        {currentTab === 1 && <SummaryPromotionsComponent />}
      </div>
    </div>
  );
};

export default ScenarioSummary;
